// @core/api/endpoints/analytics/delete_dashboard.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/analytics';

/**
 * Delete dashboard
 * Deletes a dashboard and all its widgets.
 */
export async function DeleteDashboard(
  dashboard_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/dashboards/:dashboard_id`;
  requestPath = requestPath.replace(':dashboard_id', encodeURIComponent(dashboard_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
